import api from "!../../../style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../css-loader/dist/cjs.js??ruleSet[1].rules[2].rules[1].use[1]!../../../postcss-loader/dist/cjs.js??ruleSet[1].rules[2].rules[2]!./blur.css";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};